import { CommonModule } from '@angular/common'; 
import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';
import { environment } from '../../../environments/environment';

@Component({
    imports: [CommonModule, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent],
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.page.html'
})

export class PrivacyPolicyPage implements OnInit {

  constructor(
    private metaService: Meta,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Privacy policy: gigexchange');
    this.metaService.updateTag(
      { name: 'description', property: 'og:description', content: 'GigExchange is committed to protecting the personal information of you as a user of our website.' }
    )
  }
}
